import React, { useState } from "react";
import SearchBar from "./SearchBar";
import "../css/reports.css";
import { AiFillEdit } from "react-icons/ai";
import "bootstrap/dist/css/bootstrap.min.css";
import { FaSearch } from "react-icons/fa";

const Report = ({ data, edit, onEditClick, details, onDetailClick}) => {
  const [displayData, setDisplayData] = useState(data);
  const tableHeaders = Object.keys(data[0]);
  const [currentPage, setCurrentPage] = useState(1);
  const recordsPerPage = 10;
  const lastIndex = currentPage * recordsPerPage;
  const firstIndex = lastIndex - recordsPerPage;
  const records = displayData.slice(firstIndex, lastIndex);
  const npage = Math.ceil(displayData.length / recordsPerPage);
  let numbers = [...Array(npage+1).keys()].slice(1);

  const showInfo = (retrievedData) => {
    console.log(retrievedData);
    setDisplayData(retrievedData);
    setCurrentPage(1);
  }

  function prePage(){
    if(currentPage !== 1){
        setCurrentPage(currentPage - 1);
    }
  }

  function nextPage(){
      if(currentPage !== npage){
          setCurrentPage(currentPage + 1)
      }
  }

  function changeCurrentPage(id){
      setCurrentPage(id);
  }

  return (
    <>
      <div className="search-bar-report">
        <SearchBar data={data} setData={showInfo} />
      </div>
      <table className="generic-report">
        <thead>
          <tr> 
              {details && <th className="gr-edit-column">Ver</th>}
              {edit && <th className="gr-edit-column">Editar</th>}
              {tableHeaders.map((header, index) => {
                  return <th key={index}>{header}</th>;
              })}
          </tr>
        </thead>
        <tbody>
          {records.map((item, index) => {
            return (<tr key={index}>
              {details && 
                <td>
                  <FaSearch className="gr-edit-icon" onClick={onDetailClick}/>
                </td>
                }
              {edit && 
                <td>
                  <AiFillEdit className="gr-edit-icon" onClick={() => onEditClick(item, "Editar")}/>
                </td>
              }
              {tableHeaders.map((header, index) => (
                <td key={index}>{item[header]}</td>
              ))}
            </tr>)
            })}
        </tbody>
      </table>

      {npage > 1 && 
      <div className="pagination-section">
        <nav>
          <ul className="pagination">
            <li className="page-item">
                <button className="page-link" onClick={prePage}>Anterior</button>
            </li>
            {
                numbers.map((n, i) => (
                    <li className={`page-item ${currentPage === n ? 'active' : ''}`} key={i}>
                        <button className="page-link" onClick={() => changeCurrentPage(n)}>{n}</button>
                    </li>
                ))
            }
            <li className="page-item">
                <button className="page-link" onClick={nextPage}>Siguiente</button>
            </li>
          </ul>
        </nav>
      </div>}
    </>
  );
};

export default Report;
